import { lazy, useState } from 'react'
import { NVButton } from '@nv/basic-components'
import { AlertBanner, Colon, useNVModal } from '@nv/components'
import { useAdminUserContext } from '@nv/contexts'
import { CheckAnimationIcon } from '@nv/images/design/check-animation-icon'
import QrCodeIcon from '@nv/images/design/qr-code-icon'
import { AdminVoterAuthService } from '@nv/services'
import { nxConfig } from '@nv/utils'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styles from './AdminMyAccount.module.scss'
const ConfirmQrRequest = lazy(() => import('@nv/lazy-loadable/lib/modals/ConfirmQrRequest'))

export function AdminMyAccount() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const adminUser = useAdminUserContext().adminUser
  const [requestSent, setRequestSent] = useState(false)
  const { NVModal, openModal, closeModal } = useNVModal()

  const requestRegenerateQRCode = async () => {
    const result = await AdminVoterAuthService.requestRegenerateQRCode()
    if (result.success) {
      setRequestSent(true)
      closeModal()
    }
  }

  return (
    <>
      <NVModal>
        <ConfirmQrRequest confirm={() => requestRegenerateQRCode()} />
      </NVModal>

      <div className={styles['container']}>
        <h1 className={styles['header']}>{t('pages.myAccount')}</h1>

        {requestSent && <AlertBanner icon={<CheckAnimationIcon />} text={t('auth.qrCode.requestToRegen')} success={true} />}

        <div className={styles['body']}>
          {/* USERNAME SECTION */}
          <div className={styles['body__details']}>
            <div className={styles['body__details__label']}>
              {t('form.labels.username')}
              <Colon />
            </div>
            <div className={styles['body__details__text']}>{adminUser?.username}</div>
          </div>

          {/* PASSWORD SECTION */}
          <div className={styles['body__details']}>
            <div className={styles['body__details__label']}>{t('form.labels.password')}</div>
            <div className={styles['body__details__action-container']}>
              <div className={styles['body__details__text']}>******</div>
              <NVButton variant='text' onClick={() => navigate('/admin/change-password')} text={t('buttons.change')} />
            </div>
          </div>

          {/* REGISTERED PHONE NUMBER */}
          <div className={styles['body__details']}>
            <div className={styles['body__details__label']}>
              {t('form.labels.registeredPhone')}
              <Colon />
            </div>
            <div className={styles['body__details__text']}>{adminUser?.phoneNumber}</div>
          </div>

          {/* QR CODE */}
          <div className={styles['body__details']}>
            <div className={styles['body__details__text']}>
              {nxConfig.adminAuthSelfManageEnabled ? (
                <NVButton variant='text' onClick={() => navigate('/admin/change-qr-code')} text={t('auth.qrCode.regen')} />
              ) : (
                <NVButton variant='text' onClick={() => openModal()} text={t('auth.qrCode.requestQr')} />
              )}
            </div>
            <AlertBanner icon={<QrCodeIcon style={{ width: 50, height: 50 }} />} text={t('auth.qrCode.scanQRrequired')} />
          </div>
        </div>
      </div>
    </>
  )
}
